<template>
  <el-form
    :model="form"
    :rules="rules"
    ref="ruleForm"
    @submit.native.prevent
    >
    <div class="flex flex-row w-full flex-wrap items-center">
      <div v-if="dynamicTags.length > 0">
        <el-tag
          class="pl-4 mr-2 mt-1 mb-1 tag-correo h-10 pt-1"
          :key="tag"
          v-for="tag in dynamicTags"
          closable
          :disable-transitions="false"
          @close="handleClose(tag)">
          {{tag}}
        </el-tag>
      </div>
      <div v-else>
        {{messageEmpty}}
      </div>
      <el-form-item prop="inputValue" class="input-new-tag w-full mt-1 mb-1">
        <el-input
          class="input-new-tag w-full mt-1 mb-1"
          v-if="inputVisible"
          v-model="form.inputValue"
          maxlength="320"
          ref="saveTagInput"
          @keyup.enter.native.prevent="handleInputConfirm('ruleForm')"
          @blur="handleInputConfirm('ruleForm')"
          @clear="handleInputConfirm('ruleForm')"
          >
          <template v-if="form.inputValue" slot="suffix">
            <base-clear-input-button
              aria-label="Limpiar campo"
              @clear="form.inputValue = ''"
            />
          </template>
        </el-input>
      </el-form-item>
      <base-button 
        mode='primary-phantom' 
        v-if="!inputVisible"
        :text="$t('app.add') + ' email'" 
        @click="showInput" 
      />
    </div>
  </el-form>
</template>

<script>
import { email as emailRegex } from '@/utils/regex'
import { i18n } from '@/i18n'

function isValidEmail (value) {
  if (value) return value.split(';').every(item => emailRegex.test(item))
  return false
}
export default {
  name: 'email-list-input',
  props: {
    tags: {
      type: String,
      default: ''
    },
    messageEmpty: {
      type: String,
      default: 'Añada uno o más emails para usar este aviso'
    },
    emitEvent: {
      type: String,
      default: 'sendDataCorreo'
    },
  },
  data () {
    return {
      dynamicTags: [],
      form: {
        inputValue: '',
      },
      inputVisible: false,
      rules: {
        inputValue: [
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
      }
    }
  },
  mounted () {
    this.updateInputValue()
  },
  watch: {
    tags: function () {
      this.updateInputValue()
    },
  },
  methods: {
    updateInputValue () {
      if (this.tags) {
        if (isValidEmail(this.tags)) {
          this.dynamicTags = this.tags.split(';')
        }
      } else {
        this.dynamicTags = []
      }
    },
    handleClose (tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1)
      this.onChangeTags()
    },
    showInput () {
      this.inputVisible = true
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus()
      })
    },
    handleInputConfirm (formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const inputValue = this.form.inputValue
          if (inputValue) {
            this.dynamicTags.push(inputValue)
          }
          this.inputVisible = false
          this.form.inputValue = ''
          this.onChangeTags()
        } else {
          // this.doFeedback('Error al procesar los datos, revise la información')
        }
      })
    },
    onChangeTags () {
      this.$emit(this.emitEvent, this.dynamicTags)
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!isValidEmail(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.email'), callback)
      } else {
        callback()
      }
    },
  }
}
</script>

<style lang="scss" scoped>
  .min-input-height {
    padding: .25rem 0 0.70rem 0;
  }
  .tag-correo {
    background-color: var(--Body-text-color-);
    border-color: var(--secondary-100);
    color: var(--secondary-600);
    border-width: 2px;
    font-size: 14px;
  }
  .dark .tag-correo {
    border-color: var(--darkblue-600);
    background-color: var(--darkblue-DEFAULT);
    color: var(--darkblue-300);
  }
</style>
